import { FormModel } from 'components/Form';
import { Validators } from 'utils/validators';

export const AddEditEventMappingsForm = (_strings: any, eventTypes: any[] = []): FormModel[] => {
  return [
    {
      label: 'BBR Event',
      value: '',
      size: 'medium',
      type: 'select',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: 'Select BBR event',
      field: 'eventType',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
      options: eventTypes,
    },
    {
      label: 'IDS Event Name',
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: 'IDS event name',
      field: 'eventName',
      validators: [
        { check: Validators.validateMandatoryField },
        { check: Validators.validateString, max: 50 },
      ],
      responsive: { xs: 12 },
      required: true,
    },
    {
      label: 'IDS Event Code',
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: 'IDS event code',
      field: 'eventCode',
      validators: [
        { check: Validators.validateMandatoryField },
        { check: Validators.validateString, max: 50 },
      ],
      responsive: { xs: 12 },
      required: true,
    },
  ];
};
